<div [formGroup]="tenantFormGroup" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    [placeholder]="'core.companyDialogComponent.form.name.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.name.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="additionalName"
    [placeholder]="'core.companyDialogComponent.form.additionalName.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.additionalName.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="email"
    [placeholder]="'core.companyDialogComponent.form.email.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.email.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="phone"
    [placeholder]="'core.companyDialogComponent.form.phone.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.phone.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="addressLine0"
    [placeholder]="'core.companyDialogComponent.form.addressLine1.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.addressLine1.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="addressLine1"
    [label]="'core.companyDialogComponent.form.addressLine2.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="postalCode"
    [placeholder]="'core.companyDialogComponent.form.postalCode.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.postalCode.label' | translate">
  </nx-edit-text-input>
  <nx-edit-text-input
    formControlName="city"
    [placeholder]="'core.companyDialogComponent.form.city.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.city.label' | translate">
  </nx-edit-text-input>
  <nx-edit-selectCountry-input
    formControlName="country">
  </nx-edit-selectCountry-input>
  <nx-edit-select-input
  formControlName="vatType"
  [placeholder]="'core.companyDialogComponent.form.vatType.placeholder' | translate"
  [label]="'core.companyDialogComponent.form.vatType.label' | translate"
  [options]="vatTypeOptions">
  </nx-edit-select-input>
  <nx-edit-text-input
    formControlName="vatNumber"
    [placeholder]="'core.companyDialogComponent.form.vatNumber.placeholder' | translate"
    [label]="'core.companyDialogComponent.form.vatNumber.label' | translate">
  </nx-edit-text-input>

</div>
<div>
